"use client";

import React, { useEffect, useState } from "react";
import { TableCell, TableRow } from "./ui/table";
import TaxiBox from "./TaxiBox";
import CancelAndRateBox from "./CancelAndRateBox";
import { MapPin, MessageSquareText, Contact, Car, Bus, CarTaxiFront } from "lucide-react";
import { getRecentTripOne } from "@/lib/actions/trip.actions";
import { transactionCategoryStyles } from "@/constants";
import { cn } from "@/lib/utils";

const CategoryBadge = ({ category, label }: CategoryBadgeProps) => {
  const { borderColor, backgroundColor, textColor, chipBackgroundColor } =
    transactionCategoryStyles[
      category as keyof typeof transactionCategoryStyles
    ] || transactionCategoryStyles.default;

  return (
    <div className={cn("category-badge", borderColor, chipBackgroundColor)}>
      <div className={cn("size-2 rounded-full", backgroundColor)} />
      <p className={cn("text-[12px] font-medium", textColor)}>{label}</p>
    </div>
  );
};

const RecentTripRow = ({
  localTrip,
  // updateRegularly = false,
  // updateTrip=()=>{},
}: {
  localTrip: Trip;
  // updateRegularly: boolean;
  // updateTrip: (trip: Trip) => void;
}) => {

  // const [localTrip, setLocalTrip] = useState<Trip>(trip);

  // useEffect(() => {
  //   let nextRefreshTime = 0;
  //   let interval_duration = localTrip.trip_state_duration * 1000;

  //   const refreshFunction = async () => {
  //     //console.log('refreshFunction/check refreshing', {interval_duration, wait:nextRefreshTime-Date.now()})
  //     if (!interval_duration) return;
  //     if (nextRefreshTime > Date.now()) return;

  //     console.log('refreshFunction/refreshing row ' + localTrip.course_token)
  //     try {
  //       const response_data = await getRecentTripOne({
  //         course_token: localTrip.course_token,
  //       });
  //       if (response_data && response_data.data) {
  //         setLocalTrip(response_data.data);
  //         updateTrip(response_data.data);
  //         interval_duration = response_data.data.trip_state_duration * 1000;
  //       }
  //     } catch (error) {
  //       interval_duration = interval_duration * 2;
  //     }

  //     nextRefreshTime = Date.now() + interval_duration;
  //   };

  //   if (!updateRegularly) return;
  //   if (localTrip.trip_state_duration === 0) return;

  //   console.log("refreshFunction/starting", { interval_duration });

  //   //put in place the updatef
  //   const intervalId = setInterval(() => {
  //     refreshFunction();
  //   }, 5000);
  //   return () => clearInterval(intervalId);
  // }, [localTrip.trip_state_duration, updateRegularly]);

  //to be removed
  const amount = "11111"; 
  const isDebit = true; //= t.type === 'debit';

  return (
    <TableRow
      key={localTrip.course_token}
      className={`${
        !isDebit ? "bg-[#FFFBFA]" : "bg-[#F6FEF9]"
      } !over:bg-none !border-b-DEFAULT`}
    >
      <TableCell className="max-w-[250px] pl-2 pr-4">
        <div className="flex flex-col items-center gap-3">
          <h1 className="text-14 truncate font-semibold text-[#344054]">
            {localTrip.trip_create_time}
          </h1>
          <h2 className="text-12 text-[#7B8B9A]">
            {localTrip.trip_creation_date}
          </h2>
        </div>
      </TableCell>

      <TableCell className="pl-2 pr-4">
        <div className="flex flex-col">
          <div className="flex items-center gap-2">
            <MapPin className="h-3 w-3 text-current fill-white" />
            <p className="text-xs"> {localTrip.trip_destination}</p>
          </div>
          {!!localTrip.trip_full_name && (
            <div className="flex items-center gap-2 mt-1">
              <Contact className="h-3 w-3 text-current fill-white" />
              <p className="text-xs"> {localTrip.trip_full_name}</p>
            </div>
          )}
          {!!localTrip.trip_message_for_taxi && (
            <div className="flex items-center gap-2 mt-1">
              <MessageSquareText className="h-3 w-3 text-current fill-white" />
              <p className="text-xs"> {localTrip.trip_message_for_taxi}</p>
            </div>
          )}
          {(!!localTrip.trip_vehicule_option && localTrip.trip_vehicule_option == '1') && (
            <div className="flex items-center gap-2 mt-1">
              <Car className="h-3 w-3 text-current fill-white" />
              <p className="text-xs"> Break</p>
            </div>
          )}
          {(!!localTrip.trip_vehicule_option && localTrip.trip_vehicule_option == '2') && (
            <div className="flex items-center gap-2 mt-1">
              <Bus className="h-3 w-3 text-current fill-white" />
              <p className="text-xs"> Van</p>
            </div>
          )}

          <div></div>
        </div>
      </TableCell>

      <TableCell className="min-w-32 pl-2 pr-4">
        {!!localTrip.trip_state_text && (
          <CategoryBadge
            category={localTrip.trip_state_category}
            label={localTrip.trip_state_text}
          />
        )}
      </TableCell>

      <TableCell className="pl-2 pr-4 min-w-24">
        <TaxiBox
          taxiData={localTrip.taxi_data}
          telephone={localTrip.trip_taxi_telephone}
          course_token={localTrip.course_token}
        />
      </TableCell>

      <TableCell
        className={`flex flex-col items-center   pl-2 pr-4 font-semibold ${
          isDebit || amount[0] === "-" ? "text-[#f04438]" : "text-[#039855]"
        }`}
      >
        
        <CancelAndRateBox
          course_token={localTrip.course_token}
          trip_display={localTrip.trip_display}
          box_with_cancel={localTrip.box_with_cancel}
          box_with_rate={localTrip.box_with_rate}
          rating={localTrip.rating}
        />
        <div className="text-14 px-4 py-2.5 font-semibold text-gray-700">{localTrip.earnings}</div>

      </TableCell>
    </TableRow>
  );
};

export default RecentTripRow;
